const TAB_NEW = 'newOutsourcedDpo'
const TAB_DISPLAY = 'displayOutsourcedDpo'

const tabOutsourced = {
  TAB_NEW,
  TAB_DISPLAY,
}

export default tabOutsourced
